export const isShape = shape => propObj => Object
  .keys(shape)
  .every((field) => {
    const fieldType = shape[field];
    if (Array.isArray(fieldType)) {
      return fieldType.some(type => typeof type() === typeof propObj[field]);
    }
    return typeof shape[field]() === typeof propObj[field];
  });

export const isArrayOfShapes = shape => (propArr) => {
  const shapeValidator = isShape(shape);
  return propArr.every(shapeValidator);
};
